import maObjects from "./ma_objects";

class MaRefs {
  ref: any = {};
  str: any = {
    types: {
      users: "type:5138e36b07c1031896378b37",
      workflow: "type:57d62dc9552406000d00d434",
      app: "type:5b17d9df8b5670003a56b611",
      ttsV1Profile: "type:5f0bf9fa9d992b00100eb8cd",
      ttsV2Profile: "type:5f7c605864d0770010c76c12",
      sttV1Profile: "type:5f030f2c9671d7000ccdfe82",
      sttV2Profile: "type:5f747f8764d0770010c76bd3",
      dsEngineCore: "cc_wf:5f43af6e5ebd32000fa019ea",
      dsMapsReactions: "type:5f4a47cae982ac0011aa5d8f",
      dsNode: "type:5f4214665ebd320010a01a95",
      dsNodeStore: "type:60389017166c12000f515a22",
      plugin: "type:539adaa35b82480c7dfb7a0a",
      tree: "type:5cee18067ddd74005a99ab10",
      engine_confing: "type:601a8f14166c12000e167bae",
      client_dashboard: "type:605897046a7f150008021a24",
      client_dashboard_report: "type:605893f96a7f150010021a5f",
      client_dashboard_chart_type: "type:60588ddb6a7f15000c021a33",
      // tlgrm_bot_info: "type:60373b57166c12000b2baece",
      // vk_bot_info: "type:6192380380686b000e3d66f4",
      // instagram_bot_info: "type:619238570b2bdf000ecdd2fa",
      // tlgrm_channel: "type:60b626fff637fd001064eedf",
      tlgrm_settings: "type:60b7375af637fd000c64ee6e",
      tlgrm_policies: "type:60b7353ff637fd000f64ee9f",
      // tlgrm_relations: "type:60b62874f637fd000e64ef28",
    },
    access: {
      developer: "ma_access:5c173556783bba005b8976fa",
      showOperatorRedirect: "ma_access:5eff1e039671d70009cdfe71",
      gmcAll: "ma_access:5fc0c0bb6a199300097e93dc",
      idomAdmin: "ma_access:60ed3fd8f637fd000f9492c3",
      idomOperator: "ma_access:60eed100f637fd000f9492da",
    },
    objs: {
      anonymousUser: "ma_user:513b628b07c10313a78b2946",
      pointsOfEntry: "win:5db8279aa7db700096fc6c0c",
      fbOcasApp: "fb_apps:617bcc460b2bdf000acdd2ca",
    },
    ds_event_types: {
      client_message: "ds_event_types:6087f2b553032f00082edf47",
      bot_message: "ds_event_types:6087f2c453032f000a2edf55",
      operator_message: "ds_event_types:6087f30d53032f00082edf48",
      bot_command: "ds_event_types:61126830f637fd001094a209",
      bot_timer: "ds_event_types:610cc3d5b468890008d59c4e",
      rate: "ds_event_types:61165cf9717ca2000fa9f87f",
      set_state: "ds_event_types:6132239e4874e00009757ee9",
      system_message: "ds_event_types:6140653b40417e00109f5c6b",
      error: "ds_event_types:6088f4bd53032f000e2edf8c",
    },
    ds_sources: {
      web: "ds_sources:6087f12353032f00082edf43",
      sip: "ds_sources:60893cd853032f000e2edf94",
    },
  };

  constructor() {
    for (const key of Object.keys(this.str)) {
      (this as any).ref[key] = {};
      for (const name of Object.keys((this as any).str[key])) {
        const ref = (this as any).str[key][name];
        (this as any).ref[key][name] = maObjects.str2ref(ref);
      }
    }
  }

  compareAsStr(a: any, b: any): boolean {
    if (!a || !b) return false;
    const a_str =
      typeof a == "string"
        ? a
        : a.$id && a.$ref
        ? maObjects.ref2str(a)
        : maObjects.obj2str(a);
    const b_str =
      typeof b == "string"
        ? b
        : b.$id && b.$ref
        ? maObjects.ref2str(b)
        : maObjects.obj2str(b);
    // console.log("compareAsStr a", a, " => ", a_str);
    // console.log("compareAsStr b", b, " => ", b_str);
    return a_str == b_str;
  }
}

export default new MaRefs();
